export default __webpack_public_path__ + "static/media/cover-clerk.ae12fae4.png";